import axios, {AxiosResponse} from "axios";
import BaseService from "./base-service";
import * as Endpoints from './endpoints';
import {HealthStatus} from "../types/HealthCheck";

export class MonitorService extends BaseService {

  static getHealthStatus(useCache = false): Promise<HealthStatus> {
    return axios.get(Endpoints.SOAAS_HEALTH, MonitorService.getConfig(useCache))
      .then(MonitorService.mapHealthChecks)
      .catch(BaseService.resolveErrorResponse);
  }

  private static getConfig(useCache: boolean) {
    return {
      params: {
        cache: useCache
      }
    }
  }

  private static mapHealthChecks(response: AxiosResponse): HealthStatus {
    const healthChecks = response.data.healthChecks.map((healthCheck: any) => {
      return {
        id: healthCheck.id,
        status: healthCheck.status,
        severity: healthCheck.severity,
        name: healthCheck.name,
        type: healthCheck.type,
        impact: healthCheck.impact,
        description: healthCheck.description,
        troubleshooting: healthCheck.troubleshooting,
        message: healthCheck.message
      }
    });

    return {
      status: response.data.status,
      healthChecks
    };
  }

}
